import { _ } from "js/vendor";
import { presentations as presentationsApi } from "apis-v2/callables";
import type { IPresentation } from "common/interfaces";
import db from "js/db";
import getLogger, { LogGroup } from "js/core/logger";

import ApiAdapter from "./apiAdapter";

const logger = getLogger(LogGroup.ADAPTER);

class PresentationsAdapter extends ApiAdapter<IPresentation, {}> {
    protected get _preloadedInitializationAllowed() {
        return true;
    }

    async _createApi(model: IPresentation): Promise<IPresentation> {
        throw new Error("Not supported, use createPresentationWithSlidesAndResource instead");
    }

    async _updateApi(
        changesetUpdates: Partial<IPresentation>, changesetOriginal: Partial<IPresentation>, replaceKeys: boolean = false
    ): Promise<Partial<IPresentation>> {
        ////////////////////////////////////////////////////////////////
        // TEMPORARY: Logging the details if slideRefs is set to null //
        if ("slideRefs" in (changesetUpdates ?? {}) && Object.keys(changesetUpdates.slideRefs ?? {}).length === 0) {
            logger.error(
                new Error(`[slideRefs-alert][api][presentations] updatePresentation() slideRefs was set to null`),
                "[slideRefs-alert][api][presentations] updatePresentation() slideRefs was set to null",
                {
                    changesetUpdates,
                    changesetOriginal,
                    id: this.id,
                }
            );
        }
        ////////////////////////////////////////////////////////////////

        const { modifiedAt, _changeId } = await presentationsApi.updatePresentation({
            id: this.id,
            changesetOriginal,
            changesetUpdates,
            _changeId: this.model.attributes._changeId,
            replaceKeys
        });
        return { modifiedAt, _changeId };
    }

    async _getApi(): Promise<IPresentation> {
        return await presentationsApi.getPresentation({
            id: this.id,
        });
    }

    _composeModel(baseModel: Partial<IPresentation>): IPresentation {
        return { ...baseModel, id: this.id } as IPresentation;
    }

    _getPusherChannelId(): string {
        return `private-presentation-${this.id}`;
    }

    createUid() {
        return db().push().key as string;
    }
}

export default PresentationsAdapter;
